var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.64331,
    y: 1.99988,
    width: 1.71431,
    height: 12.0002,
    rx: 0.857157,
    fill: "#212B36"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3613 14.0006C12.1019 14.0015 11.8561 13.8849 11.6927 13.6835L7.55266 8.54053C7.29267 8.22423 7.29267 7.76823 7.55266 7.45194L11.8384 2.309C12.1414 1.94448 12.6825 1.8946 13.047 2.19757C13.4115 2.50054 13.4614 3.04164 13.1585 3.40616L9.32697 8.00052L13.0299 12.5949C13.2439 12.8518 13.289 13.2097 13.1454 13.5117C13.0018 13.8136 12.6957 14.0045 12.3613 14.0006Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftEnd);
export default __webpack_public_path__ + "static/media/arrow-left-end.5ffb899ab3a4f373f3fee8f0a2d33c4b.svg";
export { ForwardRef as ReactComponent };